import './infoCard.scss';
import { FC, ReactNode } from 'react';
import { PreloadedIconKey } from '@/_config/icons';
import { Icon } from '@/comp/icon/icon';

export const InfoCard: FC<{ children: ReactNode; type?: 'small' | 'large'; icon?: PreloadedIconKey }> = ({
    children,
    icon,
    type,
}) => {
    return (
        <div className={`info-card flex ${type ? type : ''}`}>
            {icon && <Icon name={icon} ariaHidden />}
            {children}
        </div>
    );
};
export default InfoCard;
